import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { createApolloClient, OtriumApolloClient } from "src/createApolloClient";
import { locale, storeKey } from "src/config/app-config";

let browserApolloClient: OtriumApolloClient | undefined;

// Non-prod Contentful environment override, from the URL query. Read client-side
// (was previously req.query.environmentId via getInitialProps).
function getEnvironmentId(): string {
  if (
    process.env.RELEASE_STAGE === "production" ||
    typeof window === "undefined"
  ) {
    return "";
  }

  return new URLSearchParams(window.location.search).get("environmentId") || "";
}

/**
 * Returns the Apollo client for the app. A fresh client per server render; a
 * reused singleton in the browser. Locale/storeKey come from app-config and the
 * auth token from the cookie, so no getInitialProps is required — which keeps
 * Automatic Static Optimization enabled.
 */
export function getApolloClient(): ApolloClient<NormalizedCacheObject> {
  const options = { locale, storeKey, environmentId: getEnvironmentId() };

  if (typeof window === "undefined") {
    return createApolloClient(options);
  }

  if (!browserApolloClient) {
    browserApolloClient = createApolloClient(options);
  }

  return browserApolloClient;
}
